var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgService2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 173,
    height: 172,
    rx: 18.5,
    stroke: "url(#paint0_linear_1537_1308)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8363 30.3774H153.034V117.927H149.761V80.7184V76.3408V36.9436C149.761 35.7397 149.024 34.7548 148.124 34.7548H123.572H120.299H95.7467C94.8464 34.7548 94.1098 35.7397 94.1098 36.9436V76.3408V80.7184V117.927H90.8363V30.3774Z",
    fill: "url(#paint1_linear_1537_1308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.945 117.927H156.308V28.1888C156.308 26.9849 155.571 26 154.671 26H89.1996C88.2993 26 87.5627 26.9849 87.5627 28.1888V117.927H85.9259C85.0256 117.927 84.2891 118.912 84.2891 120.116V128.871C84.2891 130.074 85.0256 131.059 85.9259 131.059H157.945C158.845 131.059 159.582 130.074 159.582 128.871V120.116C159.582 118.912 158.845 117.927 157.945 117.927ZM153.034 30.3774H90.8363V117.927H94.1098H97.3835H120.299V80.7184H97.3835H94.1098V76.3408H97.3835H120.299V39.1324V34.7548H123.572V39.1324V76.3408H146.487H149.761V80.7184H146.487H123.572V117.927H146.487H149.761H153.034V30.3774ZM87.5627 126.682H156.308V122.304H87.5627V126.682Z",
    fill: "url(#paint2_linear_1537_1308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.308 126.682H87.5627V122.304H156.308V126.682Z",
    fill: "url(#paint3_linear_1537_1308)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.937 132.968C120.168 137.2 120.168 143.595 115.937 147.826C111.705 152.058 105.309 152.058 101.077 147.826L73.5488 120.297L72.8418 119.59L80.5244 111.907L74.7627 106.146L81.9385 98.9697L115.937 132.968ZM106.906 134.675C104.338 134.675 102.784 136.704 102.784 138.796C102.784 141.364 104.814 142.918 106.906 142.918C108.306 142.918 109.308 142.502 109.96 141.851C110.611 141.199 111.028 140.196 111.028 138.796C111.028 137.396 110.611 136.394 109.96 135.742C109.308 135.091 108.306 134.675 106.906 134.675Z",
    fill: "url(#paint4_linear_1537_1308)",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0474 99.1036L44.8092 95.2624L54.4123 84.3789L60.1741 90.1407L65.936 84.3789L65.2958 83.7387C66.5762 80.5377 67.2164 77.3366 67.2164 73.4954C67.2164 59.4109 55.6927 47.8872 41.6082 47.8872C37.767 47.8872 34.5659 48.5274 31.3649 49.8078L49.9309 68.3738L36.4866 81.8181L17.9206 63.2521C16.6402 66.4531 16 69.6542 16 73.4954C16 86.9397 26.2433 97.183 39.0474 99.1036Z",
    fill: "url(#paint5_linear_1537_1308)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2041 149.039L35.9121 149.746L36.0273 149.631C36.1031 149.555 36.2143 149.443 36.3574 149.3C36.6438 149.013 37.0573 148.601 37.5625 148.096L49.3555 136.303C53.9755 131.683 55.5063 127.829 56.1865 124.769C56.3538 124.016 56.4684 123.319 56.5645 122.692C56.6623 122.053 56.7377 121.515 56.833 121.02C57.0234 120.029 57.2575 119.438 57.6787 119.017C60.3423 116.353 62.5641 116.165 64.041 116.486C64.8149 116.655 65.4439 116.976 65.8809 117.259C66.0981 117.399 66.2636 117.528 66.3711 117.617C66.4244 117.662 66.4632 117.696 66.4863 117.717C66.4966 117.726 66.5039 117.734 66.5078 117.737L67.1738 118.403L67.8789 117.776L73.6406 112.655L74.4336 111.95L68.6289 106.146L104.246 70.5273L111.705 68.042L112.098 67.9111L119.647 52.8115L114.175 47.3389L113.551 47.6104L98.8262 54.0127L98.457 54.1729L98.3018 54.5449L95.1748 62.0488L60.165 97.6826L55.1172 92.6348L54.3682 91.8848L53.6631 92.6777L48.541 98.4395L47.8193 99.251L48.6885 99.9033C48.6928 99.9067 48.7009 99.9128 48.7119 99.9219C48.7364 99.9419 48.7757 99.976 48.8271 100.022C48.9304 100.116 49.0789 100.259 49.2432 100.448C49.5753 100.831 49.9537 101.38 50.1807 102.061C50.4035 102.729 50.4875 103.544 50.2168 104.504C49.9436 105.472 49.2913 106.649 47.9414 107.999C47.3285 108.612 46.6154 108.912 45.6309 109.131C45.1268 109.243 44.5812 109.328 43.9443 109.43C43.318 109.53 42.6221 109.644 41.8701 109.812C38.7992 110.494 34.9484 112.029 30.0156 116.962C28.4152 118.562 25.0546 121.924 22.0938 124.885C20.6133 126.365 19.232 127.746 18.2217 128.756L17.0176 129.96C16.8744 130.103 16.7633 130.215 16.6875 130.291C16.6496 130.329 16.6201 130.357 16.6006 130.377C16.5909 130.387 16.584 130.394 16.5791 130.399L16.5723 130.406H16.5713L16.4844 130.494L16.4209 130.6L17.1885 131.06C16.482 130.636 16.4257 130.603 16.4209 130.601L16.4199 130.602C16.4193 130.603 16.4187 130.604 16.418 130.605C16.4166 130.608 16.4148 130.61 16.4131 130.613C16.4094 130.62 16.4048 130.628 16.3994 130.638C16.3886 130.657 16.3734 130.682 16.3564 130.714C16.3225 130.777 16.2772 130.865 16.2246 130.976C16.1192 131.198 15.9836 131.516 15.8496 131.918C15.5817 132.722 15.3184 133.87 15.3184 135.275C15.3184 138.119 16.3971 141.889 20.4131 145.905C24.4291 149.921 28.1996 151 31.043 151C32.4487 151 33.5966 150.737 34.4004 150.469C34.8025 150.335 35.1202 150.199 35.3428 150.094C35.454 150.041 35.5414 149.995 35.6045 149.961C35.6361 149.944 35.6616 149.93 35.6807 149.919C35.6902 149.914 35.6987 149.909 35.7051 149.905C35.7081 149.904 35.7106 149.902 35.7129 149.9C35.714 149.9 35.7149 149.899 35.7158 149.898L35.7178 149.897C35.7167 149.894 35.6881 149.846 35.2041 149.039ZM35.2041 149.039L35.7188 149.897L35.8242 149.834L35.9111 149.747L35.2041 149.039ZM24.4551 138.796L27.5215 141.862L50.4346 118.949L47.3682 115.883L24.4551 138.796Z",
    fill: "url(#paint6_linear_1537_1308)",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_1308",
    x1: 88,
    y1: 0,
    x2: 88,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1537_1308",
    x1: 121.935,
    y1: 26,
    x2: 121.935,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1537_1308",
    x1: 121.935,
    y1: 26,
    x2: 121.935,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1537_1308",
    x1: 121.935,
    y1: 26,
    x2: 121.935,
    y2: 131.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1537_1308",
    x1: 96.1829,
    y1: 100.384,
    x2: 96.1829,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1537_1308",
    x1: 41.6082,
    y1: 47.8872,
    x2: 41.6082,
    y2: 99.1036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1537_1308",
    x1: 67.3747,
    y1: 48.5273,
    x2: 67.3747,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgService2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service2.7325e0080d6ce9b0ac4fd0be9d314ae7.svg";